// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0820e8ab] .ant-form-item {\n  margin-bottom: 0;\n}\n.contBox2[data-v-0820e8ab] {\n  display: flex;\n  align-content: center;\n}\n.contBox2 .cont[data-v-0820e8ab] {\n  flex: 1;\n  overflow: hidden;\n}\n.contBox2 .right[data-v-0820e8ab] {\n  width: 130px;\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
